<template>
    <div class="container ">
      <div class="img">
        <!-- <img src="@/assets/images/pages/forgot_password.svg"> -->
      </div>
      <div class="forgetpass-container">
        <div class="form">
          <Logo class="logo text-primary fill-current" />
          <h3>Forgot Password</h3>
          <p class="mt-4">Please enter your email address and we'll send you instructions on how to reset your password.</p>
          <div class="input-div mt-2">
            <div>
                <vs-input
                v-validate="'required|email|min:3'"
                size="large"
                type="email"
                name="email"
                icon-pack="feather"
                icon="icon-mail"
                icon-no-border
                v-model="email"
                label-placeholder="EMAIL"
                class="w-full mt-4"/>
                <span class="text-danger text-sm float-left">{{ errors.first('email') }}</span>
            </div>
          </div>
          <div class="vx-row justify-between">
          <vs-button type="border" class="vx-col shadow-md mt-4" @click="backToLogin">Back to Login</vs-button>
          <vs-button :disabled="!validateForm" @click="forgotPassword(email)" class="vx-col shadow-md mt-4">Reset Password</vs-button>
          </div>
        </div>  
      </div>
    </div>
</template>

<script>
import axios from '@/axios'
import Logo from '@/layouts/components/Logo.vue'

export default {
  components: {
    Logo
  },
  data () {
    return {
      email:''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== ''
    }
  },
  methods: {
    forgotPassword (email) {
      const headers = { 'Content-Type' : 'application/json' }
      axios.post('/auth/forgot_password', { email }, {
        headers
      })
      .then(()=>{
         this.$vs.loading()
          setTimeout(() => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Email Sent',
              text: 'Reset password email has been sent!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success',
              time: 2500
            })
            this.email = ''
          }, 1000);
      })
      .catch((err)=>{
         this.$vs.loading()
          setTimeout(() => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: 'Unable to send email',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 2500
            })
          }, 1000);
      })
    },
    backToLogin () {
    this.$vs.loading()
        setTimeout(() => {
          this.$vs.loading.close()
          this.$router.push({name: 'page-login'})
        }, 1000);
    }
  }
}
</script>

<style scoped>
* {
    padding:0;
    margin: 0;
    box-sizing: border-box;
}
body {
  display:flex;
}
.container {
  margin: auto;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(3,1fr);
    grid-template-areas: ". form .";
    grid-gap: 10rem;
    padding: 0 2rem;
}

.img{
    display: flex;
    justify-content: flex-end;
    align-items: center
}
/*
.img img{
   width: 600px; 
} */

.forgetpass-container {
    display: flex;
    place-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 80px;
    margin-bottom: 30px;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.input-div{
    display: grid;
    margin: 25px 0;
    padding: 5px 0;
    border-bottom: 2px solid #F9278E;
}


.input-div > div {
    position: relative;
    height: 45px;

}

.input-div > div h5{
    position:absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #f9278e;
    display: none;
    font-size: 18px;
    transition: .3s;
}

/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999999;
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
}

a:hover{
  color:#f9278e;
}

@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 6rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    /* .img img{
        width: 400px;
    } */
}

@media screen and (max-width: 900px) {
    /* .img{
        display:none;
    } */
    .container{
        grid-template-columns: 1fr;
    }
    .forgetpass-container{
        justify-content: center;
    }
}
</style>

